<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/company/company-list"><span
                        class="mdi mdi-arrow-left"></span></a> Add Company</h4>
        </div>

        <div class="card">
            <div class="card-body">
                <ngb-tabset #t="ngbTabset">
                    <ngb-tab id="tab-selectbyid1" title="Add Company">
                        <ng-template ngbTabContent>
                            <form [formGroup]="registerForm">
                                <h5 class="mb-3 pb-2 border-bottom mt-3 text-green">Company Information</h5>
                                <div class="form-row">

                                    <div class="col-lg-3 col-md-3 col-sm-12">
                                        <div class="form-group">
                                            <label for="">Company Name <span class="text-danger">*</span></label>
                                            <mat-form-field appearance="fill" class="w-100">
                                                <input type="text" placeholder="Company Name"
                                                    class="form-control example-no-focus py-0" aria-label="text"
                                                    matInput [matAutocomplete]="auto" maxlength="100"
                                                    formControlName="CompanyName" (input)="CmpSearchFun($event)" style="font-size: 13px!important;
                                                    color: #333; opacity: 1; font-family: sans-serif!important;">
                                                <mat-autocomplete #auto="matAutocomplete" class="w-100">
                                                    <mat-option *ngFor="let option of CmpNameId | async"
                                                        [value]="option">
                                                        {{option}}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                            <div
                                                *ngIf="registerForm.get('CompanyName').invalid && registerForm.get('CompanyName').errors && (registerForm.get('CompanyName').dirty || registerForm.get('CompanyName').touched) || submitted">
                                                <small class="text-danger"
                                                    *ngIf="registerForm.get('CompanyName').hasError('required')">
                                                    Company Name is Required
                                                </small>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-md-3 col-sm-12">
                                        <div class="form-group">
                                            <label for="">Parent Company</label>
                                            <angular2-multiselect formControlName="ParentCompany" [data]="showname"
                                                [(ngModel)]="selectedname" [settings]="dropdownSetting6"
                                                (onSelect)="onNameSelect($event)" fixSearchBug></angular2-multiselect>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-md-3 col-sm-12">
                                        <div class="form-group">
                                            <label for="">Company Type<span class="text-danger">*</span></label>
                                            <angular2-multiselect formControlName="CompanyTypeId" [data]="showtype"
                                                [(ngModel)]="selectedtype" [settings]="dropdownSetting3"
                                                (onSelect)="onTypeSelect($event)" (onDeSelect)="onTypeSelect($event)"
                                                (onSelectAll)="onTypeSelect($event)"
                                                (onDeSelectAll)="onTypeSelect($event)" fixSearchBug>
                                            </angular2-multiselect>
                                            <div
                                                *ngIf="registerForm.get('CompanyTypeId').invalid && registerForm.get('CompanyTypeId').errors && (registerForm.get('CompanyTypeId').dirty || registerForm.get('CompanyTypeId').touched) || submitted">
                                                <small class="text-danger"
                                                    *ngIf="registerForm.get('CompanyTypeId').hasError('required')">
                                                    Company Type is Required.
                                                </small>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-md-3 col-sm-12">
                                        <div class="form-group">
                                            <label for="" class="">Company Profile <span class="required">*</span>
                                            </label>
                                            <angular2-multiselect formControlName="CompanyProfileId"
                                                [data]="showprofile" [(ngModel)]="selectedprofile"
                                                [settings]="dropdownSetting10" (onSelect)="onProfileSelect($event)"
                                                fixSearchBug>
                                            </angular2-multiselect>
                                            <div
                                                *ngIf="registerForm.get('CompanyProfileId').invalid && registerForm.get('CompanyProfileId').errors && (registerForm.get('CompanyProfileId').dirty || registerForm.get('CompanyProfileId').touched) || submitted">
                                                <small class="text-danger"
                                                    *ngIf="registerForm.get('CompanyProfileId').hasError('required')">
                                                    Company Profile is Required.
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="">Business Stream <span class="required">*</span>
                                        </label>
                                        <angular2-multiselect [data]="businessStream" [(ngModel)]="selectedBusiness"
                                            [settings]="dropdownSetting4" formControlName="BusinessStreamId"
                                            (onSelect)="onBusinessSelect($event)"
                                            (onDeSelect)="onBusinessSelect($event)"
                                            (onSelectAll)="onBusinessSelect($event)"
                                            (onDeSelectAll)="onBusinessSelect($event)" fixSearchBug>
                                        </angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('BusinessStreamId').invalid && registerForm.get('BusinessStreamId').errors && (registerForm.get('BusinessStreamId').dirty || registerForm.get('BusinessStreamId').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('BusinessStreamId').hasError('required')">
                                                Business Stream is Required.
                                            </small>
                                        </div>
                                    </div>

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="">Account Manager <span class="required">*</span>
                                        </label>
                                        <angular2-multiselect [data]="showaccount" [(ngModel)]="selectedaccount"
                                            [settings]="dropdownSetting5" formControlName="AccountManager"
                                            (onSelect)="onAccountSelect($event)"
                                            (onDeSelect)="OnAccountDeSelect($event)" (onSelectAll)="onSelectAll($event)"
                                            (onDeSelectAll)="onDeSelectAll($event)" fixSearchBug></angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('AccountManager').invalid && registerForm.get('AccountManager').errors && (registerForm.get('AccountManager').dirty || registerForm.get('AccountManager').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('AccountManager').hasError('required')">
                                                Account Manager is Required.
                                            </small>
                                        </div>
                                    </div>

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="">Category <span class="required">*</span>
                                        </label>
                                        <angular2-multiselect [data]="showcategory" [(ngModel)]="selectedcategory"
                                            [settings]="dropdownSetting7" formControlName="CategoryId"
                                            (onSelect)="onCategorySelect($event)"
                                            (onDeSelect)="OnCategoryDeSelect($event)"
                                            (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"
                                            fixSearchBug>
                                        </angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('CategoryId').invalid && registerForm.get('CategoryId').errors && (registerForm.get('CategoryId').dirty || registerForm.get('CategoryId').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('CategoryId').hasError('required')">
                                                Category is Required.
                                            </small>
                                        </div>
                                    </div>

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Payment
                                            History
                                        </label>
                                        <angular2-multiselect formControlName="PaymentHistoryId" [data]="showpayment"
                                            [(ngModel)]="selectedpayment" [settings]="dropdownSetting8"
                                            (onSelect)="onPaymentSelect($event)" fixSearchBug></angular2-multiselect>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for=""
                                            class="d-flex justify-content-between align-items-center">Financial Status
                                        </label>
                                        <angular2-multiselect formControlName="FinancialStatusId" [data]="status"
                                            [(ngModel)]="selectedstatus" [settings]="dropdownSetting9"
                                            (onSelect)="onStatusSelect($event)" fixSearchBug></angular2-multiselect>
                                    </div>

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Supplier
                                            Deliver History
                                        </label>
                                        <angular2-multiselect formControlName="SupplierDeliveryHistoryId"
                                            [data]="showdelivery" [(ngModel)]="selecteddelivery"
                                            [settings]="dropdownSetting11" (onSelect)="onDeliverySelect($event)"
                                            fixSearchBug>
                                        </angular2-multiselect>
                                    </div>
                                    <div class="form-group col-lg-2 col-md-2 col-sm-12 pt-4 mt-1">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" id="a" class="custom-control-input"
                                                formControlName="KeyAccounts" />
                                            <label for="a" class="custom-control-label">Key Account</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-lg-6 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Cheque
                                            collection time
                                        </label>
                                        <textarea class="form-control form-control-sm"
                                            placeholder="Mon-10:00AM to 12:00PM and 02:00PM to 04:00PM"
                                            formControlName="ClientTime" maxlength="150"></textarea>
                                    </div>
                                </div>

                                <h5 class="mb-3 pb-2 border-bottom mt-2 text-green">General Information</h5>
                                <div class="form-row">

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex align-items-center">Country <span
                                                class="required">*</span></label>
                                        <angular2-multiselect [data]="CountryList" [(ngModel)]="selectedCountry"
                                            [settings]="dropdownSetting0" formControlName="CountryId"
                                            (onSelect)="onCountrySelect($event)" fixSearchBug></angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('CountryId').invalid && registerForm.get('CountryId').errors && (registerForm.get('CountryId').dirty || registerForm.get('CountryId').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('CountryId').hasError('required')">
                                                Country is required.
                                            </small>
                                        </div>
                                    </div>

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex align-items-center">State</label>
                                        <angular2-multiselect [data]="stateList" [(ngModel)]="selectedState"
                                            [settings]="dropdownSetting1" formControlName="StateId"
                                            (onSelect)="onStateSelect($event)" fixSearchBug>
                                        </angular2-multiselect>
                                    </div>

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex align-items-center">City</label>
                                        <angular2-multiselect [data]="cityList" [(ngModel)]="selectedCity"
                                            [settings]="dropdownSetting2" formControlName="CityId"
                                            (onSelect)="onCitySelect($event)" fixSearchBug>
                                        </angular2-multiselect>
                                    </div>

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex align-items-center">Map Location
                                        </label>
                                        <input class="form-control" type="url"
                                            [ngClass]="{ 'is-invalid': submitted && f.MapLocation.errors }"
                                            (input)="NameSpaceNotAllowed($event)"
                                            placeholder="Enter Map location URL. (Ref. Google Map)"
                                            formControlName="MapLocation" url />
                                        <div
                                            *ngIf="registerForm.get('MapLocation').invalid && registerForm.get('MapLocation').errors && (registerForm.get('MapLocation').dirty || registerForm.get('MapLocation').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('MapLocation').hasError('pattern')">
                                                Invalid Map Address
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="">Landline<span class="required">*</span>
                                        </label>
                                        <input class="form-control" type="text"
                                            placeholder="Ex. +974(Country code)444823778"
                                            [ngClass]="{ 'is-invalid': submitted && f.Landline.errors }"
                                            formControlName="Landline" maxlength="15"
                                            (keydown.space)="$event.preventDefault()" />
                                        <div *ngIf="submitted && registerForm.get('Landline').errors">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('Landline').hasError('required')">
                                                Landline is required.
                                            </small>
                                            <div *ngIf="registerForm.get('Landline').hasError('pattern')"
                                                class="text-danger">
                                                Landline is not valid.
                                            </div>
                                            <div *ngIf="registerForm.get('Landline').hasError('minLength')"
                                                class="text-danger">
                                                Landline must be at least 6 number.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="">Mobile<span class="required">*</span>
                                        </label>
                                        <input class="form-control" type="text"
                                            placeholder="Ex. +974(Country code)85432778" formControlName="Mobile"
                                            [ngClass]="{ 'is-invalid': submitted && f.Mobile.errors }" maxlength="15"
                                            (keydown.space)="$event.preventDefault()" />
                                        <div
                                            *ngIf="registerForm.get('Mobile').invalid && registerForm.get('Mobile').errors && (registerForm.get('Mobile').dirty || registerForm.get('Mobile').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('Mobile').hasError('required')">
                                                Mobile is required.
                                            </small>
                                            <div *ngIf="registerForm.get('Mobile').hasError('pattern')pattern"
                                                class="text-danger">
                                                Mobile is not valid.
                                            </div>
                                            <div *ngIf="registerForm.get('Mobile').hasError('minLength')minLength"
                                                class="text-danger">
                                                Mobile must be at least 6 number.
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Fax
                                        </label>
                                        <input class="form-control" type="text" placeholder="Ex. +974(Country code)85432778"
                                            formControlName="Fax" maxlength="25"
                                            (keydown.space)="$event.preventDefault()" />
                                        <div
                                            *ngIf="registerForm.get('Fax').invalid && registerForm.get('Fax').errors && (registerForm.get('Fax').dirty || registerForm.get('Fax').touched) || submitted">
                                            <div *ngIf="registerForm.get('Fax').hasError('pattern')pattern"
                                                class="text-danger">
                                                Fax is not valid.
                                            </div>
                                            <div *ngIf="registerForm.get('Fax').hasError('minLength')minLength"
                                                class="text-danger">
                                                Fax must be at least 6 number.
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex align-items-center">Email <span
                                                class="required ml-1"> *</span>
                                        </label>
                                        <input class="form-control" type="text" formControlName="Email"
                                            [ngClass]="{ 'is-invalid': submitted && f.Email.errors }" maxlength="150" />
                                        <div *ngIf="submitted && f.Email.errors">
                                            <small class="text-danger" *ngIf="f.Email.errors.required">Email is
                                                required</small>
                                            <div *ngIf="f.Email.errors.pattern" class="text-danger">Email must be a
                                                valid email address
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Website
                                        </label>
                                        <input class="form-control" type="text" formControlName="Website" maxlength="65"
                                            (input)="NameSpaceNotAllowed($event)" />
                                        <div
                                            *ngIf="registerForm.get('Website').invalid && registerForm.get('Website').errors && (registerForm.get('Website').dirty || registerForm.get('Website').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('Website').hasError('pattern')">
                                                Invalid Website Address
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Address
                                            1
                                        </label>
                                        <input class="form-control" type="text" formControlName="AddressLine1"
                                            maxlength="150" />
                                    </div>
                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Address
                                            2
                                        </label>
                                        <input class="form-control" type="text" formControlName="AddressLine2"
                                            maxlength="150" />
                                    </div>
                                    <div class="form-group col-lg-3 col-md-3 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">PO BOX /
                                            Zipcode
                                        </label>
                                        <input class="form-control" type="text" formControlName="PostalCode"
                                            maxlength="25" />
                                    </div>
                                </div>
                                <div class="form-row">

                                    <div class="form-group col-lg-6 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Remark
                                        </label>
                                        <textarea class="form-control form-control-sm" formControlName="Remarks"
                                            maxlength="150"></textarea>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-12">
                                        <button href="javascript:void(0);" type="submit" class="btn btn-info"
                                            (click)="onSubmit()" [disabled]="multiClick">Save</button>
                                        <a href="javascript:void(0);" class="btn btn-secondary ml-2"
                                            routerLink="/company/company-list">Cancel</a>
                                    </div>
                                </div>
                            </form>
                        </ng-template>
                        <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                    </ngb-tab>
                </ngb-tabset>
            </div>
        </div>
    </div>
</div>